// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"242":"f13ac19e","357":"a6e9fadc","425":"0e82c13e","851":"38d7b46d","941":"c218cf36"}[chunkId] + ".chunk.css";
};